module.exports = {
          srcSet: __webpack_public_path__ + "8f93bd4cc9673dd453d09ad098a5ca95-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "8f93bd4cc9673dd453d09ad098a5ca95-180.png",width: 180,height: 180}],
          src: __webpack_public_path__ + "8f93bd4cc9673dd453d09ad098a5ca95-180.png",
          toString:function(){return __webpack_public_path__ + "8f93bd4cc9673dd453d09ad098a5ca95-180.png"},
          
          width: 180,
          height: 180
        }